var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLayoutEffect, useState } from 'react';
import { useGame } from './useGame';
export function useQuery(queryDef) {
    var game = useGame();
    // stored as a static reference.
    var _a = __read(useState(function () { return game.queryManager.create(queryDef); }), 1), query = _a[0];
    var _b = __read(useState(Math.random()), 2), _ = _b[0], setForceUpdate = _b[1];
    useLayoutEffect(function () {
        function onEntitiesChanged() {
            setForceUpdate(Math.random());
        }
        query.on('entityAdded', onEntitiesChanged);
        query.on('entityRemoved', onEntitiesChanged);
        return function () {
            query.off('entityAdded', onEntitiesChanged);
            query.off('entityRemoved', onEntitiesChanged);
        };
    }, [query]);
    return query.entities;
}
//# sourceMappingURL=useQuery.js.map